module.exports = __webpack_public_path__ + "img/fig01.a4f43ed8.jpg";